module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_0@2x.4a65f538.png";